import DatePicker from '../../common/DatePicker';
import Input from '../../common/Input';
import {TIME_RANGE_DATE_FORMAT} from "./worktime";

export default {
  filter_date_option: {
    label: '',
      placeholder: '',
      source: [
        {
          value: 'due',
          text: 'Due',
        },
        {
          value: 'did',
          text: 'Created',
        },
    ],
      system: {
      name: 'filter_date_option',
    },
    value: 'due',
    errors: [],
    type: 'text',
    name: 'filter_date_option',
    rules: {
    title: '',
      required: false,
    }
  },
  filter_date_from: {
    label: 'Filter From',
    placeholder: 'Pick a date',
    value: '',
    errors: [],
    style: {
      grid: null,
    },
    system: {
      component: DatePicker,
      name: null,
    },
    rules: {
      title: null,
    },
    timeFormat: false,
    dateFormat: TIME_RANGE_DATE_FORMAT
  },
  filter_date_to: {
    label: 'Filter To',
    placeholder: 'Pick a date',
    value: '',
    errors: [],
    style: {
      grid: null,
    },
    system: {
      component: DatePicker,
      name: null,
    },
    rules: {
      title: null,
    },
    timeFormat: false,
    dateFormat: TIME_RANGE_DATE_FORMAT
  },
  filter_fi: {
    label: 'Has Financial Info',
    placeholder: '',
    system: {
      name: 'filter_fi',
    },
    value: false,
    errors: [],
    type: 'checkbox',
    name: 'filter_fi',
    rules: {
      title: '',
    }
  },
  status: {
    label: 'Quote Status',
    placeholder: 'Add quote status',
    source: [
      {
        value: 'all',
        text: 'All',
      },
      {
        value: 'new',
        text: 'New',
      },
      {
        value: 'hold',
        text: 'Hold',
      },
      {
        value: 'in_progress',
        text: 'In Progress',
      },
      {
        value: 'hot',
        text: 'HOT',
      },
      {
        value: 're_work',
        text: 'Re-work',
      },
      {
        value: 'ready',
        text: 'Ready',
      },
      {
        value: 'closed',
        text: 'Closed',
      },
    ],
    system: {
      name: 'status',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'status',
    rules: {
      title: 'Quote status field',
      required: false,
    }
  },
  group_by: {
    label: 'Group By',
    placeholder: 'Add quote status',
    source: [
      {
        value: 'work_order',
        text: 'Work Order',
      },
      {
        value: 'employee',
        text: 'Employee',
      },
      {
        value: 'activity',
        text: 'Activity',
      },
      {
        value: 'customer',
        text: 'Customer',
      },
    ],
    system: {
      name: 'status',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'status',
    rules: {
      title: 'Quote status field',
      required: false,
    }
  },
  time_range: {
    label: 'Time range',
    placeholder: 'Time range',
    timeFormat: false,
    open: false,
    input: true,
    viewMode: 'days',
    system: {
      name: 'time_range',
      clearable: false,
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'time_range',
    rules: {
      title: '',
      required: false,
    }
  },
  worker_filter: {
    label: 'Worker',
    placeholder: 'Worker',
    timeFormat: false,
    open: false,
    input: true,
    viewMode: 'days',
    system: {
      name: 'worker_filter',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'worker_filter',
    rules: {
      title: '',
      required: false,
    }
  },
  work_order_filter: {
    label: 'Work Order',
    placeholder: 'Work Order',
    system: {
      component: Input,
      name: 'work_order_filter',
      relatedTo: 'details',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'work_order_filter',
    rules: {
      title: 'Work Order',
      required: false,
    }
  },

  show_was_fixed: {
    label: 'Was Fixed',
    placeholder: '',
    value: 0,
    errors: [],
    style: {
      grid: null,
    },
    system: {
      name: null,
    },
  },
  show_diagram: {
    label: 'Show Diagram',
    placeholder: '',
    value: 0,
    errors: [],
    style: {
      grid: null,
    },
    system: {
      name: null,
    },
  },
};



// WEBPACK FOOTER //
// ./src/containers/Reports/field.js